import { isPresent } from 'Shared/utils';
import {
  AddressCategoryType,
  isInsuranceApplication,
  ServerErrorResponseType,
  transformAppDetails,
} from '../GetDetails';
import { PostStartResponseType, ServerResponseType } from './types';

const allowedOutcomes = ['mailable', 'unavailable', 'vacant', 'overridden'];

export const transformAddressOutcomes = (
  response: ServerResponseType,
  addressType: AddressCategoryType
) => {
  const addressIdentifier = response.insuranceApplication.attributes.identifier;
  const firstAddress = response.insuranceApplication.attributes.addresses.find(
    address => address.attributes.identifier === addressIdentifier
  );
  const residencyAddress = response.insuranceApplication.attributes.addresses.find(
    address =>
      address.attributes.addressType.value === 'residency' &&
      address.attributes.identifier === addressIdentifier
  );
  const mailingAddress = response.insuranceApplication.attributes.addresses.find(
    address =>
      address.attributes.addressType.value === 'mailing' &&
      address.attributes.identifier === addressIdentifier
  );

  if (addressType === 'residency' && residencyAddress) {
    const outcome = isPresent(residencyAddress)
      ? residencyAddress.attributes.addressValidationOutcome.value || ''
      : '';
    const isAddressValid = allowedOutcomes.includes(outcome);
    const isMissingLineTwo = outcome === 'missing_line_two';

    return {
      isAddressValid,
      isMissingLineTwo,
    };
  }
  if (addressType === 'mailing' && mailingAddress) {
    const outcome = isPresent(mailingAddress)
      ? mailingAddress.attributes.addressValidationOutcome.value || ''
      : '';
    const isAddressValid = allowedOutcomes.includes(outcome);
    const isMissingLineTwo = outcome === 'missing_line_two';

    return {
      isAddressValid,
      isMissingLineTwo,
    };
  }

  const outcome = isPresent(firstAddress)
    ? firstAddress.attributes.addressValidationOutcome.value || ''
    : '';
  const isAddressValid = allowedOutcomes.includes(outcome);
  const isMissingLineTwo = outcome === 'missing_line_two';

  // If no address of the requested type is found, we assume the first address is valid.
  return {
    isAddressValid,
    isMissingLineTwo,
  };
};

export const transformPostStartStepResponse = (
  response: ServerResponseType | ServerErrorResponseType
): PostStartResponseType => {
  if (isInsuranceApplication(response)) {
    return {
      ...transformAddressOutcomes(response, 'residency'),
      appDetails: transformAppDetails(response),
    };
  } else {
    // server returned an error, so we throw an error and the consumer handles these errors.
    throw new Error(response.message);
  }
};
